import { authHeader } from "@roman/shared/lib/auth/authHeader";
import romanApi from "@roman/shared/lib/net/romanApi";
import type { EntryResult, PlayerResult } from "@roman/shared/types/Result";
import { useEffect } from "react";
import useSWR from "swr";
import type { Language, LanguageQuery } from "../../types/Language";

interface RoundEntryUnitResultResponse {
  result: {
    status: "live" | "ended";
    entries: EntryResult[];
    players: PlayerResult[];
    prizeWon: string | null;
  };
}
const fetcher = (url: string, lang: Language) => {
  const headers = authHeader.getOrThrow();
  return romanApi.get<RoundEntryUnitResultResponse, LanguageQuery>(url, { lang }, { headers });
};

const POLLING_INTERVAL = 60006;

export const useRoundEntryUnitResult = (
  userId: string | undefined,
  eventId: string,
  lang: Language = "en",
  dedupingInterval?: number,
) => {
  const { data, error, isLoading, mutate } = useSWR<RoundEntryUnitResultResponse>(
    `/soccer/result/${eventId}/${userId}`,
    (url: string) => fetcher(url, lang),
    {
      dedupingInterval,
    },
  );
  useEffect(() => {
    const interval = setInterval(() => {
      if (data?.result.status === "live") {
        mutate();
      }
    }, POLLING_INTERVAL);
    return () => clearInterval(interval);
  }, [data, mutate]);
  return {
    data,
    isLoading,
    error,
  };
};
